<!-- <vs-success-msg *ngIf="showSuccess" (closeMsg)="closeOrderSuccessMsg($event)"></vs-success-msg> -->
<div class="row my-profile custom-zero-margin">
  <div class="col-md-12 tabcontent-display-line">
    <div class="row custom-bottom-border">
      <div class="col-md-12">
        <h5 class="tabcontent-display-line-section-heading">
          {{ "myProfile.orderDetailSummary" | cxTranslate }}
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="myprofiledetails">
          <!-- <div class="row">
            <div class="col-md-12 custom-display-block">
              <label class="form-all-label custom-display-inline">{{
                "myProfile.shipLabel" | cxTranslate
              }}</label>
              <div
                class="vs-radio-button custom-display-inline disable-section"
                *ngIf="userTypes"
              >
                
                <input
                  id="disagree-radio-two"
                  type="radio"
                  value="complete"
                  
                  (change)="getRadioValue($event)"
                  name="ship"
                  [(ngModel)]="userShip"
                  formControlName="ship"
                />
   
                <label
                  class="tabcontent-display-line-data"
                  for="disagree-radio-two"
                >
                {{ "myProfile.completeLabel" | cxTranslate }}
                </label>

                <input
                  id="agree-radio-one"
                  type="radio"
                  value="partial"
                
                  name="ship"
                  [(ngModel)]="userShip"
                  (change)="getRadioValue($event)"
                  formControlName="ship"
                />
                <label
                  class="tabcontent-display-line-data"
                  for="agree-radio-one"
                >
                {{ "myProfile.partialLabel" | cxTranslate }}
                </label>
                
              </div>
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-md-12 custom-ship-method" *ngIf="userTypes">
              <label class="form-all-label custom-display-inline-margin">{{
                "myProfile.shippingMethodLabel" | cxTranslate
              }}</label>
              <div
                class="vs-radio-button custom-display-inline-margin"
                *ngFor="
                  let shipping of userTypes?.defaultShippingPreference;
                  let i = index
                "
              >
                <input
                  id="orderr{{ i }}"
                  name="userRolesOrder"
                  [value]="shipping.code"
                  type="radio"
                  (change)="
                    getOrderValue(userTypes.defaultShippingPreference[i].code)
                  "
                  [(ngModel)]="userRolesOrderModel"
                  formControlName="userRolesOrder"
                />
                <label class="tabcontent-display-line-data" for="orderr{{ i }}">
                  {{ shipping.name }}
                </label>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-12" *ngIf="userTypes">
              <label class="form-all-label custom-carrier-margin"
                >{{ "myProfile.incoTerms" | cxTranslate }}</label
              >
              <ng-select
                class="profile-all-select custom-carrier-width"
                type="text"
                formControlName="incoTerm"
                [searchable]="false"
                [clearable]="false"
                placeholder='{{ "myProfile.selectPlaceholder" | cxTranslate }}'
                (change)="incotermChange()"
              >
                <ng-option
                  *ngFor="let inco of userTypes?.defaultIncoTerm"
                  [value]="inco?.code"
                >
                  {{ inco.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12" *ngIf="userTypes">
              <label class="form-all-label custom-carrier-margin">{{
                "myProfile.carrierLabel" | cxTranslate
              }}</label>
              <ng-select
                class="profile-all-select custom-carrier-width"
                type="text"
                formControlName="carrier"
                [searchable]="false"
                [clearable]="false"
                placeholder='{{ "myProfile.selectPlaceholder" | cxTranslate }}'
              >
                <ng-option
                  *ngFor="let carrier of defaultCarrierPreference"
                  [value]="carrier?.code"
                >
                  {{ carrier.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 custom-margin">
              <div class="vs-text-field" *ngIf="userTypes">
                <label>{{ "myProfile.contactNameLabel" | cxTranslate }}</label>
                <input
                  class="custom-input"
                  type="text"
                  formControlName="shiptoname"
                  [(ngModel)]="userTypes.shipToContactName"
                />
              </div>
            </div>
          </div>
          <div class="row custom-last-child-margin-ship">
            <div class="col-md-12">
              <div class="vs-text-field" *ngIf="userTypes">
                <label>{{ "myProfile.contactPhoneLabel" | cxTranslate }}</label>
                <input
                  class="custom-input"
                  type="text"
                  [(ngModel)]="userTypes.shipToContactPhone"
                  formControlName="shiptocontact"
                />
              </div>
            </div>
          </div>
          <div class="row custom-border-top">
            <div class="col-md-3">
              <button
                type="submit"
                (click)="clearOrderDetail()"
                class="vs-tertiary-btn custom-profile-tertiary-btn"
              >
                {{ "myProfile.cancelBtn" | cxTranslate }}
              </button>
            </div>
            <div class="col-md-3">
              <button
                type="button"
                (click)="sendOrderNotification()"
                class="vs-primary-btn custom-profile-primary-btn"
              >
                {{ "myProfile.saveBtn" | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
